import { createTheme } from "@mui/material/styles";

const MUI_THEME = createTheme({
  palette: {
    primary: {
      main: "#003B95",
      light: "#1863D6",
    
    },
    secondary: {
      main: "#000000",
      light: "#ffffff",
    },
    customColor: {
      dustyGray: "#999999",
      tundora: "#4D4D4D",
      scorpion: "#5D5D5D",
      blueRomance: "#CCF6D7", // light green
      malachite: "#02BB34", // Green
      alto: "#DBDBDB", // light gray (0.2)
      gray: "#888888", // gray
      tequila: "#FFE7CB", // light orange
      tahitiGold: "#EA7E03", // orange
      palePink: "#FFCBCB", // light pink
      darkRed: "#B12E2E", // dark red
      moonRaker:"#D1E0F7" // light blue
    },
  },

  typography: {
    fontFamily: ["Inter", "sans-serif"].join(","),
    color: "#4D4D4D",
    h5: {
      color: "#4D4D4D",
    },
    body1: {
      color: "#4D4D4D",
    },
  },

  shadows: ["0px 0px 6px 0px #00000040", "0px 0px 6px 0px #00000040"],

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Inter",
          textTransform: "capitalize",
          borderRadius: "8px",
          width: "100%",
          height: "100%",
          boxShadow: "none",
        },
        suspend_button: {
          border: "2px solid #B12E2E",
          color: "#B12E2E",
          fontSize: "1rem",
          backgroundColor: "#ffffff",
        },
        custom_outlined: {
          border: "2px solid #003B95",
          color: "#003B95",
          fontSize: "1rem",
          backgroundColor: "#ffffff",
        },
        tab_button: {
          fontSize: "1rem",
          backgroundColor: "#ffffff",
          borderRadius:"8px"
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
      styleOverrides: {
        root: {
          "&.MuiFormControl-root .MuiOutlinedInput-root .MuiInputBase-input": {
            padding: "12px 10px",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #BDBDBD`,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #BDBDBD`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #BDBDBD`,
            },
          },
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginTop: 0,
          },
          "& .Mui-disabled": {
            cursor: "not-allowed",
          },
        },
      },
    },
  },
});

export default MUI_THEME;
